import Notification from './Notification';
import { NotificationProvider, useNotification } from './NotificationContext';

export default Notification;
export { NotificationProvider, useNotification };
